document.addEventListener("DOMContentLoaded", function () {
    var carouselItems = document.querySelectorAll('.carousel .carousel-item');
    var minPerSlide = 3;
    carouselItems.forEach(function (item) {
        var nextItem = item.nextElementSibling || item.parentElement.firstElementChild;
        var clonedChild = nextItem.firstElementChild.cloneNode(true);
        item.appendChild(clonedChild);
        for (var i = 0; i < minPerSlide; i++) {
            nextItem = nextItem.nextElementSibling || item.parentElement.firstElementChild;
            var clonedChild = nextItem.firstElementChild.cloneNode(true);
            item.appendChild(clonedChild);
        }
    });

    // handling to open mobile offcanvas catalog menu
    var bntOpenPanel = document.querySelector('#btn_open_panel');
    bntOpenPanel && bntOpenPanel.addEventListener('click', function () {
        document.querySelector('.panel').classList.toggle('panel-opened');
    });

    // scroll to top
    let mybutton = document.getElementById("btn_back_to_top");
    window.onscroll = () => {
        mybutton.style.display = (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) ? "block" : "none";
    };
    mybutton.addEventListener("click", () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    });

    // hiding announce block if it's the last shown toast
    var hideButtons = document.querySelectorAll('[data-bs-hide="announces"]');
    hideButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            var announcesContainer = this.closest('.announces');
            if (announcesContainer) {
                var showElements = announcesContainer.querySelectorAll('.show');
                if (showElements.length == 1) {
                    announcesContainer.style.display = 'none';
                }
            }
        });
    });

    // toasts after adding to the cart or favorites
    var cartButtons = document.querySelectorAll('[data-bs-toast="toast_cart"]');
    cartButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            var toastCart = bootstrap.Toast.getOrCreateInstance(document.getElementById('toast_cart'));
            toastCart.show();
        });
    });
    var favButtons = document.querySelectorAll('[data-bs-toast="toast_fav"]');
    favButtons && favButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            var toastFav = bootstrap.Toast.getOrCreateInstance(document.getElementById('toast_fav'));
            toastFav.show();
        });
    });

    // showing stock in the cart and favorites
    var switchButtons = document.querySelectorAll('.btn-basket');
    switchButtons && switchButtons.forEach(function (switchButton) {
        switchButton.addEventListener('click', function () {
            var headerElement = this.closest('.basket-item');
            if (headerElement) {
                var stockElement = headerElement.querySelector('.basket-item-stock');
                if (stockElement) {
                    stockElement.classList.toggle('d-none');
                    this.querySelectorAll('span').forEach(function (spans) {
                        spans.classList.toggle('d-none');
                    });
                }
            }
        });
    });

    let showMorePhotos = document.querySelector('#show-more-photos button');

    showMorePhotos && showMorePhotos.addEventListener('click', function () {
        document.querySelectorAll('.gallery li').forEach((item) => {
            item.removeAttribute('class');
        });

        this.remove();
    });

    var sort = document.getElementById('sort');
    sort && sort.addEventListener("change", function () {
        const urlParams = new URLSearchParams(window.location.search);

        urlParams.set('sort', sort.value);

        window.location.search = urlParams;
    });


    // highlights cells of the size chart table
    document.querySelectorAll('#itemSizeTable tr > *').forEach(cell => {
        cell.addEventListener('mouseenter', function () {
            clearHighlights();
            highlightCells(this);
        });

        cell.addEventListener('touchstart', function () {
            clearHighlights(); // Clear previous highlights on tap
            highlightCells(this);
        });
    });

    function highlightCells(cell) {
        const row = cell.parentNode;
        const table = row.parentNode;
        const cellIndex = Array.from(row.children).indexOf(cell);

        // Highlight cells to the left in the same row
        for (let i = 0; i < row.children.length; i++) {
            row.children[i].classList.add('item-size-table-trace');
            if (i === cellIndex) {
                row.children[i].classList.add('item-size-table-highlight');
            }
        }

        // Highlight cells above in the same column
        for (let i = 0; i <= row.rowIndex; i++) {
            table.rows[i].cells[cellIndex].classList.add('item-size-table-trace');
        }
    }

    function clearHighlights() {
        document.querySelectorAll('#itemSizeTable tr > *').forEach(cell => {
            cell.classList.remove('item-size-table-trace');
            cell.classList.remove('item-size-table-highlight');
        });
    }

    document.addEventListener("DOMContentLoaded", function () {
        var sourceElement = document.getElementById('catalog_item_description_text');
        var targetElement = document.getElementById('description_about_text');
        if (sourceElement && targetElement) {
            var sourceText = sourceElement.textContent || sourceElement.innerText;
            var plainText = sourceText.replace(/<[^>]*>/g, '');
            var truncatedText = plainText.substring(0, 140) + "...";
            targetElement.textContent = truncatedText;
        }
    });

    // var source = document.querySelectorAll('.filter');
    //
    // if(source) {
    //     var cloned = source[0].cloneNode(true);
    //     var recepient = document.querySelectorAll('.offcanvas-body-filter');
    //     recepient[0].appendChild(cloned);
    // }

    // Клонирование фильтров для мобильных
    let source = document.querySelectorAll('.filter');
    let cloned = source[0].cloneNode(true);
    let recepient = document.querySelectorAll('.offcanvas-body-filter');
    recepient[0].appendChild(cloned);

    // Отмена фильтра
    document.querySelectorAll('.catalog-filter_close').forEach(item => {
        item.addEventListener('click', function () {
            let paramName = item.getAttribute('data-param');

            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            let newParams = new URLSearchParams();

            params.delete(paramName + '*');
            params.forEach((val, key) => {
                if (!key.startsWith(paramName)) {
                    newParams.append(key, val);
                }
            });

            url.search = newParams.toString();
            window.location.href = url.toString();
        });
    });
});
